module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='comment-reply' notranslate='notranslate'>\n  <div class='avatar-presenter'>\n    <div class='avatar-wrapper small'>\n      <img class='avatar' src='" + ($e($c(this.reply.authorable_avatar_url))) + "'>\n    </div>\n    <div class='presenter-wrapper'>\n      <div class='flex-v-center flex-wrapper'>\n        <div class='flex-column'>\n          <h5 class='author-reply'>" + ($e($c(this.reply.authorable_name))) + "</h5>\n        </div>\n        <div class='actions flex-column'>\n          <div class='" + (['timestamp', 'subtext', 'tooltip-hover', "" + ($e($c(!this.reply.read ? 'updated' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n            <div class='friendly'>\n              <span class='js-localized-datetime' notranslate data-behavior='localized-relative-time-ago' data-timestamp='" + ($e($c(this.reply.created_at))) + "'>");
      $o.push("                " + $c(this.reply.created_at_friendly));
      $o.push("              </span>\n            </div>\n            <div class='tooltip'>\n              <div class='tooltip-inner-wrapper'>\n                <span class='js-localized-datetime' notranslate data-behavior='localized-datetime' data-format-type='datetime' data-timestamp='" + ($e($c(this.reply.created_at))) + "'>");
      $o.push("                  " + $c(this.reply.created_at));
      $o.push("                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class='body markdown-styles'>");
      $o.push("        " + $c(this.markdown.toHTML(this.boldAllMentionedUsers(this.reply.body, this.reply.id, this.reply.updated_at)).autoLink({
        target: "_blank"
      })));
      $o.push("      </div>\n    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/comments/comment_reply.js.hamlc
// module id = 1416
// module chunks = 17